import http from 'config/http'
import { PUBLIC_ACCESS } from 'utils/constants'

export const getDeploymentsDataAction = async (offset = 0, limit = 50, isPublic = false, search = '') => {
  const token = localStorage.getItem('session')
  try {
    let payload = await http
      .get(`deployments?from=${offset}&to=${limit}&public=${isPublic}${search ? `&model=${search}` : ''}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data)
    return {
      data: payload.deployments || [],
      total: payload.total || 0,
    }
  } catch (err) {
    console.log(err)
  }
}

export const createDeploymentAction = async (data, callback) => {
  const token = localStorage.getItem('session')
  const authHeader = token ? { Authorization: `Bearer ${token}` } : PUBLIC_ACCESS
  try {
    const deployment = await http
      .post('deployments', data, {
        headers: {
          ...authHeader,
        },
      })
      .then((res) => res.data)

    callback({
      file: deployment.job?.files?.length > 0 ? deployment.job?.files : null,
      suggestedModels: deployment.job?.output?.suggested_models,
      imageTags: deployment.job?.output?.image_tags,
      id: deployment.job?.id,
      eta: deployment.job?.eta,
      name: deployment.name,
      model_id: deployment.model_id,
      credits_used: deployment.job?.credits_used,
      created_at: deployment.job?.created_at,
      status: deployment.job?.status,
      deploymentId: deployment.id,
    })
  } catch (err) {
    callback()
  }
}

export const getDeploymentByIdAction = (id) => {
  try {
    const token = localStorage.getItem('session')
    return http
      .get(`deployments/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data)
  } catch (err) {
    console.error(err)
  }
}

export const updateDeploymentAction = async (id, permission, errorCallback) => {
  const token = localStorage.getItem('session')
  try {
    await http
      .patch(
        `deployments/${id}`,
        {
          permission,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => res.data)
    return true
  } catch (err) {
    errorCallback()
    return false
  }
}

export const rateDeploymentAction = async (id, rating, callback) => {
  const token = localStorage.getItem('session')
  try {
    await http
      .patch(
        `deployments/rate`,
        {
          id,
          rating,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => res.data)
    callback(true)
  } catch (err) {
    return false
  }
}

export const getDeploymentJobAction = (id) => {
  try {
    const token = localStorage.getItem('session')
    return http
      .get(`jobs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data)
  } catch (err) {
    console.error(err)
    throw err
  }
}
